import { Component, AfterViewInit, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';


@Component({
  selector: 'storage-stockreorganisation',
  providers: [StorageService],
  templateUrl: './stockreorganisation.component.html',
  styleUrls: ['./stockreorganisation.component.scss']
})
export class StockreorganisationComponent implements AfterViewInit, OnInit {

  parcelCode: string;

  storages: any[] = [];
  checkStorages: any[] = [];
  private storage: any = null;

  scannedValue: string = null;
  private container: any = null;
  containerName: string = '';
  loadedContainer: boolean = false;  
  loadedParcel: boolean = false;  

  filterTitle: string;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    private _dialogService: TdDialogService,
    public renderer: Renderer) {
  }

  //@ViewChild('ft01') infocus: ElementRef;

  ngOnInit(): void {
    this._titleService.setTitle('Stock Reorganisation');
    this.load();
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('stockreorganisation.list');
      this.loadFilter('Stock Reorganisation');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('stockreorganisation.list');
    }
  }

  async loadContainer(containerName: string): Promise<void> {
    try {
      //validate container: it must exist
      this.container = await this._storageService.getContainer(containerName).toPromise();
      this.containerName = this.container.name;
      this.loadedContainer = true;
      this.storage.containerName = this.containerName;
      await this._storageService.updateStorage(this.storage, 'REORGANISATION_STOCK').toPromise();
      this.scannedValue = null;
      this.goBack();
    } catch (error) {
      //container does not exist
      this.loadedContainer = false;
      this.containerName = '';
      this._dialogService.openAlert({ message: 'Cannot save parcel!'});
    } finally {
    }
  }

  isContainerLoaded() {
    return this.loadedContainer;
  }

  isParcelLoaded() {
    return this.loadedParcel;
  }

  async loadParcel(value: string): Promise<void> {
    try {
        this.parcelCode = value;
        // get parcel
        await this.getParcel(value);
    } catch (error) {
        this.storage = null;
        this.loadedParcel = false;
        this.scannedValue = null;
        console.log('Cannot loadParcel!');
    } finally {
    }
  }


  async getParcel(reference: string): Promise<void> {
    try{
          this.storages = await this._storageService.getParcel(reference).toPromise();
          this.storage = this.storages[0]; // for normal ch einlagern we assume we only get one
          this.loadedParcel = true;
    } catch (error) {
        console.log('Cannot get parcel!');
        this.storage = null;
        this.loadedParcel = false;
    } finally {
    }
  }


  keytab(event, from: string, to: string){

    if (from == 'scannedValue') {
      this.loadParcel(this.scannedValue);
    } else if (from == 'containerName') {
      this.loadContainer(this.containerName);
    }

    let element = event.path[5]; // naviagte to md-card-content
    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (event.path[5].children[j].innerText == to) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

  goBack(): void {
   // this.clearForm();
    this.container = null;
    this.containerName = '';
    this.loadedContainer = false;

    this._router.navigate(['/storage/reorganisation']);
  }

  clearForm() {
    this.parcelCode = '';
    this.storage = null;
    this.loadedParcel = false;
    this.load();
    this.scannedValue = null;
    this.goBack();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/storage/form/stockreorganisation.component.ts